import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { ProjectCategorySchemas } from "../ea.schema";
import { CountResponseSchema } from "../ea.schema.endpoints";

const base = "projects-category";
const projectsCategory = createEndpointBase(base);

export const projectsCategoryEndpoints = {
  projectsCategoryGet: projectsCategory({
    method: "GET",
    path: "",
    request: z.any(),
    response: z.array(ProjectCategorySchemas["general"]),
    description: "Retrieves a list of project categories with filtering support.",
  }),
  projectsCategoryCount: projectsCategory({
    method: "GET",
    path: "count",
    request: z.any(),
    response: CountResponseSchema,
    description: "Returns the total number of project categories matching the filters.",
  }),
  projectsCategoryCreate: projectsCategory({
    method: "POST",
    path: "",
    request: ProjectCategorySchemas["createData"],
    response: z.any(),
    description: "Creates a new project category.",
  }),
  projectsCategoryUpdate: projectsCategory({
    method: "PATCH",
    path: ":id",
    request: ProjectCategorySchemas["update"],
    response: z.any(),
    description: "Updates an existing project category.",
  }),
  projectsCategoryDelete: projectsCategory({
    method: "DELETE",
    path: ":id",
    request: z.object({ id: z.number() }),
    response: z.any(),
    description: "Permanently deletes a project category.",
  }),
} as const;
